import { ListBase } from './../tools/ListBase';


class MailTemplates extends ListBase {

  constructor ({props, context}) {
    super();
    this.state = {rows: [], cls: 'mailtemplates'};
    this.title = 'Mail Template';
    this.state.columns = [
      {
        field: 'MailFrom',
        headerName: 'Mail From',
        width: 250,
      },
      {
        field: 'Subject',
        headerName: 'Subject',
        width: 250,
      },
    ];
  }

}


import { useNavigate } from 'react-router-dom';

function MailTemplatesWithNavigate(props) {
  const navigate = useNavigate();
  return <MailTemplates {...props} navigate={navigate} />;
}

export default MailTemplatesWithNavigate;